import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      usersCount: 0,
    };
  },

  computed: {
    ...mapGetters({
      product: 'subscription/product',
      selectedPlan: 'subscription/selectedPlan',
    }),

    legacySubscription() {
      return this.loggedInUser() && this.loggedInUser()._legacy_subscription;
    },

    pricePerUser() {
      let price = 0;
      if (this.selectedPlan.tiers) {
        const selectedTier = this.selectedPlan.tiers.find(
          tier => this.usersCount <= parseInt(tier.up_to, 10) || !tier.up_to,
        );

        price = selectedTier ? selectedTier.unit_amount : 0;
      }
      return parseInt(price, 10);
    },

    total() {
      return this.pricePerUser * this.usersCount;
    },
  },

  async mounted() {
    this.usersCount = this.initialUsersCount();
    await this.getPlan({
      slug: this.$route.query.plan,
      interval: this.$route.query.interval,
    });
  },

  methods: {
    ...mapActions({
      getPlan: 'subscription/getPlan',
    }),
    initialUsersCount() {
      const usersQuery = this.$route.query.users;
      if (usersQuery) {
        return parseInt(usersQuery, 10);
      }

      if (!this.legacySubscription) {
        return 1;
      }

      if (this.legacySubscription.users && this.legacySubscription.users.count && this.legacySubscription.quantity) {
        const usersCount = this.legacySubscription.users.count;
        const subscriptionQuantity = this.legacySubscription.quantity;
        return usersCount > subscriptionQuantity ? usersCount : subscriptionQuantity;
      }

      return 1;
    },
  },
};
